<template>
  <div style="margin-top:57px">
    <q-card
      style="padding:25px 15px;background:#fff"
      v-if="!loading && vehicles.length === 0"
    >
      <empty-value name="vehicles"></empty-value>
    </q-card>

    <q-card
      class="loading-infinite"
      style="height:250px"
      v-if="loading && vehicles.length === 0"
    >
      <div>
        <q-spinner-facebook color="primary" size="40px" />
        <div class="text-grey-7">Loading</div>
      </div>
    </q-card>
    <div
      v-else-if="loading && vehicles.length > 0"
      style="text-align:center;padding:10px 0px"
    >
      <q-spinner-facebook color="primary" size="40px" />
    </div>
  </div>
</template>

<script>
import EmptyValue from "./EmptyValue";
export default {
  data() {
    return {
      sort: {
        name: "",
        count: 0,
      },
      all: false,
      selection: [],
      columns: [
        {
          name: "Unit",
          val: "unit",
        },
        {
          name: "VIN",
          val: "vin",
        },
        {
          name: "Brand",
          val: "brand",
        },
        {
          name: "Model",
          val: "model",
        },
        {
          name: "Year",
          val: "model_year",
        },

        {
          name: "Class",
          val: "class_name",
        },
        {
          name: "Location",
          val: "location",
        },
      ],
    };
  },
  components: {
    EmptyValue,
  },
  watch: {
    all(n, o) {
      if (n) {
        this.selection = [];
        this.vehicles.map((item) => {
          this.selection.push(item);
        });
      } else {
        this.selection = [];
      }
    },
    selection: {
      deep: true,
      handler(n, o) {},
    },
  },
  methods: {
    sortTable(row) {
      this.sort.name === row.name ? this.sort.count++ : "";
      this.sort.name = row.name;
      const order = this.sort.count % 2 == 0 ? "asc" : "desc";
      const deep = [...this.vehicles];
      const sorted = deep.sort(this.sortVehicles(row.val, order));
      this.vehicles = sorted;
    },
    sortVehicles(key, order) {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        var varA, varB;

        if (typeof a[key] === "string") {
          varA = a[key].toUpperCase();
        } else if (typeof a[key] === "object") {
          varA = a[key].name.toUpperCase();
        } else varA = a[key];

        if (typeof b[key] === "string") {
          varB = b[key].toUpperCase();
        } else if (typeof b[key] === "object") {
          varB = b[key].name.toUpperCase();
        } else varB = b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },
    isInclude(val) {
      const have = this.selection.some((item) => item.id == val.id);
      if (have) {
        const index = this.selection.map((item) => item.id).indexOf(val.id);
        this.selection.splice(index, 1);
      } else {
        this.selection.push(val);
      }
    },
  },
  computed: {
    vehicles: {
      get() {
        return this.$store.state.vehicle.vehicles;
      },
      set(val) {
        this.$store.commit("vehicle/SET_VEHICLES", val);
      },
    },
    loading() {
      return this.$store.state.vehicle.loading;
    },
    bgChanger() {
      return (val) => {
        const index = this.selection.map((item) => item.id).indexOf(val.id);
        if (index != -1) {
          return "background:#fff";
        }
      };
    },
  },
};
</script>
